import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    formContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
  };
};
